/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { account_details_AccountDetails } from '../models/account_details_AccountDetails';
import type { account_details_AccountDetailsSchemaItems } from '../models/account_details_AccountDetailsSchemaItems';
import type { allocation_report_WeightedAllocationReport } from '../models/allocation_report_WeightedAllocationReport';
import type { api_v2_analytics_choices_EnumSchemaItems } from '../models/api_v2_analytics_choices_EnumSchemaItems';
import type { api_v2_analytics_reports_ListReportSchemaItems } from '../models/api_v2_analytics_reports_ListReportSchemaItems';
import type { api_v2_analytics_reports_SavedReportDetails } from '../models/api_v2_analytics_reports_SavedReportDetails';
import type { api_v2_analytics_unsaved_reports_UnsavedReportDetails } from '../models/api_v2_analytics_unsaved_reports_UnsavedReportDetails';
import type { api_v2_analytics_unsaved_reports_UpdateUnsavedReport } from '../models/api_v2_analytics_unsaved_reports_UpdateUnsavedReport';
import type { api_v2_calculate_portfolio_analytics_PortfolioAnalyticsResult } from '../models/api_v2_calculate_portfolio_analytics_PortfolioAnalyticsResult';
import type { api_v2_data_calc_params_CalcParam } from '../models/api_v2_data_calc_params_CalcParam';
import type { api_v2_data_calc_params_CalcParamSchemaItems } from '../models/api_v2_data_calc_params_CalcParamSchemaItems';
import type { app_v1_settings_AppSettings } from '../models/app_v1_settings_AppSettings';
import type { b2b_v1_advisor_client_Client } from '../models/b2b_v1_advisor_client_Client';
import type { b2b_v1_advisor_client_ClientDetailsResult } from '../models/b2b_v1_advisor_client_ClientDetailsResult';
import type { b2b_v1_advisor_client_ClientPassword } from '../models/b2b_v1_advisor_client_ClientPassword';
import type { b2b_v1_advisor_client_ClientResult } from '../models/b2b_v1_advisor_client_ClientResult';
import type { b2b_v1_advisor_client_ClientResultSchemaItems } from '../models/b2b_v1_advisor_client_ClientResultSchemaItems';
import type { b2b_v1_advisor_client_ShareLinkToken } from '../models/b2b_v1_advisor_client_ShareLinkToken';
import type { b2b_v1_advisor_holding_reports_CreateHoldingsReport } from '../models/b2b_v1_advisor_holding_reports_CreateHoldingsReport';
import type { b2b_v1_advisor_holding_reports_CreateHoldingsReportResponse } from '../models/b2b_v1_advisor_holding_reports_CreateHoldingsReportResponse';
import type { b2b_v1_advisor_holding_reports_HoldingsReportExportResponse } from '../models/b2b_v1_advisor_holding_reports_HoldingsReportExportResponse';
import type { b2b_v1_advisor_holding_reports_HoldingsReportResponse } from '../models/b2b_v1_advisor_holding_reports_HoldingsReportResponse';
import type { b2b_v1_advisor_holding_reports_HoldingsReportSchemaItems } from '../models/b2b_v1_advisor_holding_reports_HoldingsReportSchemaItems';
import type { b2b_v1_advisor_holding_reports_HoldingsReportSchemaItems1 } from '../models/b2b_v1_advisor_holding_reports_HoldingsReportSchemaItems1';
import type { b2b_v1_advisor_holdings_collection_link_CreateHoldingsCollectionLink } from '../models/b2b_v1_advisor_holdings_collection_link_CreateHoldingsCollectionLink';
import type { b2b_v1_advisor_holdings_collection_link_HoldingsCollectionLinkResponse } from '../models/b2b_v1_advisor_holdings_collection_link_HoldingsCollectionLinkResponse';
import type { b2b_v1_advisor_holdings_collection_link_HoldingsCollectionLinkResponseSchemaItems } from '../models/b2b_v1_advisor_holdings_collection_link_HoldingsCollectionLinkResponseSchemaItems';
import type { b2b_v1_advisor_integrations_OrgIntegrations } from '../models/b2b_v1_advisor_integrations_OrgIntegrations';
import type { b2b_v1_advisor_settings_DeleteFlanksCredentialsResponse } from '../models/b2b_v1_advisor_settings_DeleteFlanksCredentialsResponse';
import type { b2b_v1_advisor_settings_JobStartedResponse } from '../models/b2b_v1_advisor_settings_JobStartedResponse';
import type { b2b_v1_advisor_settings_OrgAdminSettings } from '../models/b2b_v1_advisor_settings_OrgAdminSettings';
import type { b2b_v1_advisor_settings_OrgSettings } from '../models/b2b_v1_advisor_settings_OrgSettings';
import type { b2b_v1_advisor_users_CreateUser } from '../models/b2b_v1_advisor_users_CreateUser';
import type { b2b_v1_advisor_users_UserDetails } from '../models/b2b_v1_advisor_users_UserDetails';
import type { b2b_v1_advisor_users_UserDetailsSchemaItems } from '../models/b2b_v1_advisor_users_UserDetailsSchemaItems';
import type { b2b_v1_analytics_CreateDefaultReport } from '../models/b2b_v1_analytics_CreateDefaultReport';
import type { b2b_v1_analytics_CreateReport } from '../models/b2b_v1_analytics_CreateReport';
import type { b2b_v1_analytics_RenameReport } from '../models/b2b_v1_analytics_RenameReport';
import type { b2b_v1_analytics_UpdateCharts } from '../models/b2b_v1_analytics_UpdateCharts';
import type { b2b_v1_asset_allocation_AssetAllocationFullResult } from '../models/b2b_v1_asset_allocation_AssetAllocationFullResult';
import type { b2b_v1_asset_allocation_AssetAllocationResult } from '../models/b2b_v1_asset_allocation_AssetAllocationResult';
import type { b2b_v1_asset_allocation_AssetAllocationResultSchemaItems } from '../models/b2b_v1_asset_allocation_AssetAllocationResultSchemaItems';
import type { b2b_v1_asset_allocation_CreateAssetAllocation } from '../models/b2b_v1_asset_allocation_CreateAssetAllocation';
import type { b2b_v1_asset_allocation_UpdateAssetAllocation } from '../models/b2b_v1_asset_allocation_UpdateAssetAllocation';
import type { b2b_v1_asset_allocation_UpsertAssetAllocationItems } from '../models/b2b_v1_asset_allocation_UpsertAssetAllocationItems';
import type { b2b_v1_auth_Login } from '../models/b2b_v1_auth_Login';
import type { b2b_v1_auth_User } from '../models/b2b_v1_auth_User';
import type { b2b_v1_calc_param_CreateCalcParamB2B } from '../models/b2b_v1_calc_param_CreateCalcParamB2B';
import type { b2b_v1_calc_param_ImportCalcParam } from '../models/b2b_v1_calc_param_ImportCalcParam';
import type { b2b_v1_calc_param_ImportCalcParamResponse } from '../models/b2b_v1_calc_param_ImportCalcParamResponse';
import type { b2b_v1_calc_param_UpdateCalcParamB2B } from '../models/b2b_v1_calc_param_UpdateCalcParamB2B';
import type { b2b_v1_connect_ConnectComplete } from '../models/b2b_v1_connect_ConnectComplete';
import type { b2b_v1_connect_ConnectDelete } from '../models/b2b_v1_connect_ConnectDelete';
import type { b2b_v1_connect_ConnectInit } from '../models/b2b_v1_connect_ConnectInit';
import type { b2b_v1_connect_ConnectInitResponse } from '../models/b2b_v1_connect_ConnectInitResponse';
import type { b2b_v1_connect_ConnectStart } from '../models/b2b_v1_connect_ConnectStart';
import type { b2b_v1_connect_ConnectUpdate } from '../models/b2b_v1_connect_ConnectUpdate';
import type { b2b_v1_connect_StatusMessageResult } from '../models/b2b_v1_connect_StatusMessageResult';
import type { b2b_v1_core_UrlResponse } from '../models/b2b_v1_core_UrlResponse';
import type { b2b_v1_demo_OrganizationSchemaItems } from '../models/b2b_v1_demo_OrganizationSchemaItems';
import type { b2b_v1_feedback_Feedback } from '../models/b2b_v1_feedback_Feedback';
import type { b2b_v1_pensions_PensionInput } from '../models/b2b_v1_pensions_PensionInput';
import type { b2b_v1_pensions_PensionMeta } from '../models/b2b_v1_pensions_PensionMeta';
import type { b2b_v1_pensions_PensionOutput } from '../models/b2b_v1_pensions_PensionOutput';
import type { b2b_v1_portfolio_builder_asset_list_AssetListFilterWarning } from '../models/b2b_v1_portfolio_builder_asset_list_AssetListFilterWarning';
import type { b2b_v1_portfolio_builder_asset_list_AssetListMetaSchemaItems } from '../models/b2b_v1_portfolio_builder_asset_list_AssetListMetaSchemaItems';
import type { b2b_v1_portfolio_builder_asset_list_AssetListResult } from '../models/b2b_v1_portfolio_builder_asset_list_AssetListResult';
import type { b2b_v1_portfolio_builder_asset_list_AssetListResultSchemaItems } from '../models/b2b_v1_portfolio_builder_asset_list_AssetListResultSchemaItems';
import type { b2b_v1_portfolio_builder_asset_list_CreateAssetList } from '../models/b2b_v1_portfolio_builder_asset_list_CreateAssetList';
import type { b2b_v1_portfolio_builder_asset_list_filter_AssetsListFilter } from '../models/b2b_v1_portfolio_builder_asset_list_filter_AssetsListFilter';
import type { b2b_v1_portfolio_builder_asset_list_filter_AssetsListFilterSchemaItems } from '../models/b2b_v1_portfolio_builder_asset_list_filter_AssetsListFilterSchemaItems';
import type { b2b_v1_portfolio_builder_asset_list_filter_BatchOutputAssetListFilter } from '../models/b2b_v1_portfolio_builder_asset_list_filter_BatchOutputAssetListFilter';
import type { b2b_v1_portfolio_builder_asset_list_filter_ImportAssetListsFilters } from '../models/b2b_v1_portfolio_builder_asset_list_filter_ImportAssetListsFilters';
import type { b2b_v1_portfolio_builder_asset_list_filter_UpdateAssetListFilterList } from '../models/b2b_v1_portfolio_builder_asset_list_filter_UpdateAssetListFilterList';
import type { b2b_v1_portfolio_builder_asset_list_ImportProductLists } from '../models/b2b_v1_portfolio_builder_asset_list_ImportProductLists';
import type { b2b_v1_portfolio_builder_asset_list_ImportProductListsResponse } from '../models/b2b_v1_portfolio_builder_asset_list_ImportProductListsResponse';
import type { b2b_v1_portfolio_builder_asset_list_UpdateAssetList } from '../models/b2b_v1_portfolio_builder_asset_list_UpdateAssetList';
import type { b2b_v1_portfolio_builder_portfolio_benchmark_CreatePortfolioBenchmark } from '../models/b2b_v1_portfolio_builder_portfolio_benchmark_CreatePortfolioBenchmark';
import type { b2b_v1_portfolio_builder_portfolio_proposal_BookPortfolioProposalResponse } from '../models/b2b_v1_portfolio_builder_portfolio_proposal_BookPortfolioProposalResponse';
import type { b2b_v1_portfolio_builder_portfolio_proposal_CreateExternalPosition } from '../models/b2b_v1_portfolio_builder_portfolio_proposal_CreateExternalPosition';
import type { b2b_v1_portfolio_builder_portfolio_proposal_CreatePortfolioProposal } from '../models/b2b_v1_portfolio_builder_portfolio_proposal_CreatePortfolioProposal';
import type { b2b_v1_portfolio_builder_portfolio_proposal_ExternalPosition } from '../models/b2b_v1_portfolio_builder_portfolio_proposal_ExternalPosition';
import type { b2b_v1_portfolio_builder_portfolio_proposal_OptimalPortfolioProposalCalcsResponse } from '../models/b2b_v1_portfolio_builder_portfolio_proposal_OptimalPortfolioProposalCalcsResponse';
import type { b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalCalcs } from '../models/b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalCalcs';
import type { b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalCalcsResponse } from '../models/b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalCalcsResponse';
import type { b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalFullResult } from '../models/b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalFullResult';
import type { b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalResult } from '../models/b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalResult';
import type { b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalResultSchemaItems } from '../models/b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalResultSchemaItems';
import type { b2b_v1_portfolio_builder_portfolio_proposal_UpdateExternalPosition } from '../models/b2b_v1_portfolio_builder_portfolio_proposal_UpdateExternalPosition';
import type { b2b_v1_portfolio_builder_portfolio_proposal_UpdatePortfolioProposal } from '../models/b2b_v1_portfolio_builder_portfolio_proposal_UpdatePortfolioProposal';
import type { b2b_v1_portfolio_builder_portfolio_template_CreatePortfolioTemplate } from '../models/b2b_v1_portfolio_builder_portfolio_template_CreatePortfolioTemplate';
import type { b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResult } from '../models/b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResult';
import type { b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResultSchemaItems } from '../models/b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResultSchemaItems';
import type { b2b_v1_portfolio_builder_portfolio_template_UpdatePortfolioTemplate } from '../models/b2b_v1_portfolio_builder_portfolio_template_UpdatePortfolioTemplate';
import type { b2b_v1_users_Account } from '../models/b2b_v1_users_Account';
import type { b2b_v1_users_AccountSchemaItems } from '../models/b2b_v1_users_AccountSchemaItems';
import type { b2b_v1_users_AccountUpdate } from '../models/b2b_v1_users_AccountUpdate';
import type { b2b_v1_users_Position } from '../models/b2b_v1_users_Position';
import type { b2b_v1_users_PositionDetailsSchemaItems } from '../models/b2b_v1_users_PositionDetailsSchemaItems';
import type { b2b_v1_users_PositionsCreate } from '../models/b2b_v1_users_PositionsCreate';
import type { b2b_v1_users_PositionUpdate } from '../models/b2b_v1_users_PositionUpdate';
import type { connections_DataSessionConnectionSchemaItems } from '../models/connections_DataSessionConnectionSchemaItems';
import type { core_OrganizationSchemaItems } from '../models/core_OrganizationSchemaItems';
import type { data_providers_DataProviderSchemaItems } from '../models/data_providers_DataProviderSchemaItems';
import type { data_providers_DataProviderSchemaItems1 } from '../models/data_providers_DataProviderSchemaItems1';
import type { instrument_InstrumentInfoResponse } from '../models/instrument_InstrumentInfoResponse';
import type { instrument_InstrumentPrice } from '../models/instrument_InstrumentPrice';
import type { instrument_InstrumentsSearchSchemaItems } from '../models/instrument_InstrumentsSearchSchemaItems';
import type { instrument_PaginatedInstrumentsSearch } from '../models/instrument_PaginatedInstrumentsSearch';
import type { marshmallow_schema_ColumnChoices } from '../models/marshmallow_schema_ColumnChoices';
import type { marshmallow_schema_InstrumentTypes } from '../models/marshmallow_schema_InstrumentTypes';
import type { marshmallow_schema_SourceChoices } from '../models/marshmallow_schema_SourceChoices';
import type { portfolio_benchmark_PortfolioBenchmark } from '../models/portfolio_benchmark_PortfolioBenchmark';
import type { portfolio_benchmark_PortfolioBenchmarkSchemaItems } from '../models/portfolio_benchmark_PortfolioBenchmarkSchemaItems';
import type { portfolio_benchmark_PortfoliosBenchmarkResult } from '../models/portfolio_benchmark_PortfoliosBenchmarkResult';
import type { portfolio_benchmark_UpdatePortfolioBenchmark } from '../models/portfolio_benchmark_UpdatePortfolioBenchmark';
import type { positions_report_Positions } from '../models/positions_report_Positions';
import type { positions_report_PositionsInput } from '../models/positions_report_PositionsInput';
import type { recovery_ResetPassword } from '../models/recovery_ResetPassword';
import type { recovery_SendResetPasswordEmailOrg } from '../models/recovery_SendResetPasswordEmailOrg';
import type { risk_report_RiskReport } from '../models/risk_report_RiskReport';
import type { summary_report_AccountSummary } from '../models/summary_report_AccountSummary';
import type { summary_report_ClientSummary } from '../models/summary_report_ClientSummary';
import type { summary_report_PositionSummary } from '../models/summary_report_PositionSummary';
import type { system_status_SystemStatusEventsBodySchemaItems } from '../models/system_status_SystemStatusEventsBodySchemaItems';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DefaultService {
    /**
     * /b2b/v1/advisor/accounts/<client_id>
     * @param clientId
     * @returns account_details_AccountDetailsSchemaItems
     * @throws ApiError
     */
    public static getB2BV1AdvisorAccounts(
        clientId: string,
    ): CancelablePromise<account_details_AccountDetailsSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/accounts/{client_id}',
            path: {
                'client_id': clientId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/accounts/<client_id>/<account_id>
     * @param accountId
     * @param clientId
     * @returns account_details_AccountDetails
     * @throws ApiError
     */
    public static getB2BV1AdvisorAccounts1(
        accountId: string,
        clientId: string,
    ): CancelablePromise<account_details_AccountDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/accounts/{client_id}/{account_id}',
            path: {
                'account_id': accountId,
                'client_id': clientId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/calculate/allocations/clients/<client_id>/accounts/<account_id>
     * @param accountId
     * @param clientId
     * @param acceptLanguage
     * @returns allocation_report_WeightedAllocationReport
     * @throws ApiError
     */
    public static postB2BV1AdvisorCalculateAllocationsClientsAccounts(
        accountId: string,
        clientId: string,
        acceptLanguage?: 'en' | 'sv',
    ): CancelablePromise<allocation_report_WeightedAllocationReport> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/calculate/allocations/clients/{client_id}/accounts/{account_id}',
            path: {
                'account_id': accountId,
                'client_id': clientId,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
        });
    }
    /**
     * /b2b/v1/advisor/calculate/allocations/positions
     * @param acceptLanguage
     * @param requestBody
     * @returns allocation_report_WeightedAllocationReport
     * @throws ApiError
     */
    public static postB2BV1AdvisorCalculateAllocationsPositions(
        acceptLanguage?: 'en' | 'sv',
        requestBody?: positions_report_PositionsInput,
    ): CancelablePromise<allocation_report_WeightedAllocationReport> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/calculate/allocations/positions',
            headers: {
                'Accept-Language': acceptLanguage,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/clients
     * @param clientIds
     * @param organization
     * @throws ApiError
     */
    public static deleteB2BV1AdvisorClients(
        clientIds: string,
        organization: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/advisor/clients',
            query: {
                'client_ids': clientIds,
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/advisor/clients
     * @param organization
     * @returns b2b_v1_advisor_client_ClientResultSchemaItems
     * @throws ApiError
     */
    public static getB2BV1AdvisorClients(
        organization: string,
    ): CancelablePromise<b2b_v1_advisor_client_ClientResultSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/clients',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/advisor/clients
     * @param requestBody
     * @returns b2b_v1_advisor_client_ClientResult
     * @throws ApiError
     */
    public static postB2BV1AdvisorClients(
        requestBody?: b2b_v1_advisor_client_Client,
    ): CancelablePromise<b2b_v1_advisor_client_ClientResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/clients',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/clients/<client_id>
     * @param clientId
     * @throws ApiError
     */
    public static deleteB2BV1AdvisorClients1(
        clientId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/advisor/clients/{client_id}',
            path: {
                'client_id': clientId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/clients/<client_id>
     * @param clientId
     * @returns b2b_v1_advisor_client_ClientDetailsResult
     * @throws ApiError
     */
    public static getB2BV1AdvisorClients1(
        clientId: string,
    ): CancelablePromise<b2b_v1_advisor_client_ClientDetailsResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/clients/{client_id}',
            path: {
                'client_id': clientId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/clients/<client_id>
     * @param clientId
     * @param requestBody
     * @returns b2b_v1_advisor_client_ClientDetailsResult
     * @throws ApiError
     */
    public static patchB2BV1AdvisorClients(
        clientId: string,
        requestBody?: b2b_v1_advisor_client_Client,
    ): CancelablePromise<b2b_v1_advisor_client_ClientDetailsResult> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/advisor/clients/{client_id}',
            path: {
                'client_id': clientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/clients/<client_id>
     * @param clientId
     * @param requestBody
     * @returns b2b_v1_advisor_client_ClientDetailsResult
     * @throws ApiError
     */
    public static putB2BV1AdvisorClients(
        clientId: string,
        requestBody?: b2b_v1_advisor_client_Client,
    ): CancelablePromise<b2b_v1_advisor_client_ClientDetailsResult> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/advisor/clients/{client_id}',
            path: {
                'client_id': clientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/clients/<client_id>/accounts/<account_id>/position/summary
     * @param accountId
     * @param clientId
     * @param endDate
     * @param startDate
     * @param ticker Ticker for the security. For cash positions use CASH.SEK.
     * @returns summary_report_PositionSummary
     * @throws ApiError
     */
    public static getB2BV1AdvisorClientsAccountsPositionSummary(
        accountId: string,
        clientId: string,
        endDate: string,
        startDate: string,
        ticker: string,
    ): CancelablePromise<summary_report_PositionSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/clients/{client_id}/accounts/{account_id}/position/summary',
            path: {
                'account_id': accountId,
                'client_id': clientId,
            },
            query: {
                'end_date': endDate,
                'start_date': startDate,
                'ticker': ticker,
            },
        });
    }
    /**
     * /b2b/v1/advisor/clients/<client_id>/accounts/<account_id>/summary
     * @param accountId
     * @param clientId
     * @param endDate
     * @param startDate
     * @param acceptLanguage
     * @returns summary_report_AccountSummary
     * @throws ApiError
     */
    public static getB2BV1AdvisorClientsAccountsSummary(
        accountId: string,
        clientId: string,
        endDate: string,
        startDate: string,
        acceptLanguage?: 'en' | 'sv',
    ): CancelablePromise<summary_report_AccountSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/clients/{client_id}/accounts/{account_id}/summary',
            path: {
                'account_id': accountId,
                'client_id': clientId,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'end_date': endDate,
                'start_date': startDate,
            },
        });
    }
    /**
     * /b2b/v1/advisor/clients/<client_id>/password
     * @param clientId
     * @param requestBody
     * @returns b2b_v1_advisor_client_Client
     * @throws ApiError
     */
    public static postB2BV1AdvisorClientsPassword(
        clientId: string,
        requestBody?: b2b_v1_advisor_client_ClientPassword,
    ): CancelablePromise<b2b_v1_advisor_client_Client> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/clients/{client_id}/password',
            path: {
                'client_id': clientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/clients/<client_id>/risk
     * @param clientId
     * @param fixedCorrelation
     * @param useWeeklyReturns
     * @returns risk_report_RiskReport
     * @throws ApiError
     */
    public static getB2BV1AdvisorClientsRisk(
        clientId: string,
        fixedCorrelation?: number,
        useWeeklyReturns: boolean = false,
    ): CancelablePromise<risk_report_RiskReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/clients/{client_id}/risk',
            path: {
                'client_id': clientId,
            },
            query: {
                'fixed_correlation': fixedCorrelation,
                'use_weekly_returns': useWeeklyReturns,
            },
        });
    }
    /**
     * /b2b/v1/advisor/clients/<client_id>/summary
     * @param clientId
     * @param endDate
     * @param startDate
     * @param acceptLanguage
     * @param accountIds
     * @returns summary_report_ClientSummary
     * @throws ApiError
     */
    public static getB2BV1AdvisorClientsSummary(
        clientId: string,
        endDate: string,
        startDate: string,
        acceptLanguage?: 'en' | 'sv',
        accountIds?: string,
    ): CancelablePromise<summary_report_ClientSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/clients/{client_id}/summary',
            path: {
                'client_id': clientId,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'account_ids': accountIds,
                'end_date': endDate,
                'start_date': startDate,
            },
        });
    }
    /**
     * /b2b/v1/advisor/clients/<client_id>/token
     * @param clientId
     * @returns b2b_v1_advisor_client_ShareLinkToken
     * @throws ApiError
     */
    public static postB2BV1AdvisorClientsToken(
        clientId: string,
    ): CancelablePromise<b2b_v1_advisor_client_ShareLinkToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/clients/{client_id}/token',
            path: {
                'client_id': clientId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/data-providers
     * @param all
     * @param organization
     * @returns data_providers_DataProviderSchemaItems
     * @throws ApiError
     */
    public static getB2BV1AdvisorDataProviders(
        all?: boolean,
        organization?: string,
    ): CancelablePromise<data_providers_DataProviderSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/data-providers',
            query: {
                'all': all,
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/advisor/holding-reports/<client_id>
     * @param clientId
     * @returns b2b_v1_advisor_holding_reports_HoldingsReportSchemaItems
     * @throws ApiError
     */
    public static getB2BV1AdvisorHoldingReports(
        clientId: string,
    ): CancelablePromise<b2b_v1_advisor_holding_reports_HoldingsReportSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/holding-reports/{client_id}',
            path: {
                'client_id': clientId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/holding-reports/<client_id>
     * @param clientId
     * @param requestBody
     * @returns b2b_v1_advisor_holding_reports_CreateHoldingsReportResponse
     * @throws ApiError
     */
    public static postB2BV1AdvisorHoldingReports(
        clientId: string,
        requestBody?: b2b_v1_advisor_holding_reports_CreateHoldingsReport,
    ): CancelablePromise<b2b_v1_advisor_holding_reports_CreateHoldingsReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/holding-reports/{client_id}',
            path: {
                'client_id': clientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/holding-reports/<client_id>/<report_id>
     * @param clientId
     * @param reportId
     * @throws ApiError
     */
    public static deleteB2BV1AdvisorHoldingReports(
        clientId: string,
        reportId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/advisor/holding-reports/{client_id}/{report_id}',
            path: {
                'client_id': clientId,
                'report_id': reportId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/holding-reports/<client_id>/<report_id>
     * @param clientId
     * @param reportId
     * @param acceptLanguage
     * @returns b2b_v1_advisor_holding_reports_HoldingsReportResponse
     * @throws ApiError
     */
    public static getB2BV1AdvisorHoldingReports1(
        clientId: string,
        reportId: string,
        acceptLanguage?: 'en' | 'sv',
    ): CancelablePromise<b2b_v1_advisor_holding_reports_HoldingsReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/holding-reports/{client_id}/{report_id}',
            path: {
                'client_id': clientId,
                'report_id': reportId,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
        });
    }
    /**
     * /b2b/v1/advisor/holding-reports/<client_id>/<report_id>/pdf
     * @param clientId
     * @param reportId
     * @param taskId
     * @param acceptLanguage
     * @returns b2b_v1_advisor_holding_reports_HoldingsReportExportResponse
     * @throws ApiError
     */
    public static getB2BV1AdvisorHoldingReportsPdf(
        clientId: string,
        reportId: string,
        taskId: string,
        acceptLanguage?: 'en' | 'sv',
    ): CancelablePromise<b2b_v1_advisor_holding_reports_HoldingsReportExportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/holding-reports/{client_id}/{report_id}/pdf',
            path: {
                'client_id': clientId,
                'report_id': reportId,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'task_id': taskId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/holding-reports/<client_id>/<report_id>/pdf
     * @param clientId
     * @param reportId
     * @param acceptLanguage
     * @returns b2b_v1_advisor_holding_reports_HoldingsReportExportResponse
     * @throws ApiError
     */
    public static postB2BV1AdvisorHoldingReportsPdf(
        clientId: string,
        reportId: string,
        acceptLanguage?: 'en' | 'sv',
    ): CancelablePromise<b2b_v1_advisor_holding_reports_HoldingsReportExportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/holding-reports/{client_id}/{report_id}/pdf',
            path: {
                'client_id': clientId,
                'report_id': reportId,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
        });
    }
    /**
     * /b2b/v1/advisor/holding-reports/<client_id>/<report_id>/pdf/result
     * @param clientId
     * @param reportId
     * @param taskId
     * @returns binary
     * @throws ApiError
     */
    public static postB2BV1AdvisorHoldingReportsPdfResult(
        clientId: string,
        reportId: string,
        taskId: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/holding-reports/{client_id}/{report_id}/pdf/result',
            path: {
                'client_id': clientId,
                'report_id': reportId,
            },
            query: {
                'task_id': taskId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/holdings-collection-links
     * @param clientId
     * @returns b2b_v1_advisor_holdings_collection_link_HoldingsCollectionLinkResponseSchemaItems
     * @throws ApiError
     */
    public static getB2BV1AdvisorHoldingsCollectionLinks(
        clientId?: string,
    ): CancelablePromise<b2b_v1_advisor_holdings_collection_link_HoldingsCollectionLinkResponseSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/holdings-collection-links',
            query: {
                'client_id': clientId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/holdings-collection-links
     * @param requestBody
     * @returns b2b_v1_advisor_holdings_collection_link_HoldingsCollectionLinkResponse
     * @throws ApiError
     */
    public static postB2BV1AdvisorHoldingsCollectionLinks(
        requestBody?: b2b_v1_advisor_holdings_collection_link_CreateHoldingsCollectionLink,
    ): CancelablePromise<b2b_v1_advisor_holdings_collection_link_HoldingsCollectionLinkResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/holdings-collection-links',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/instruments/search
     * @param q
     * @param page
     * @param types
     * @returns instrument_PaginatedInstrumentsSearch
     * @throws ApiError
     */
    public static getB2BV1AdvisorInstrumentsSearch(
        q: string,
        page?: number,
        types?: string,
    ): CancelablePromise<instrument_PaginatedInstrumentsSearch> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/instruments/search',
            query: {
                'page': page,
                'q': q,
                'types': types,
            },
        });
    }
    /**
     * /b2b/v1/advisor/instruments/<ticker>/info
     * @param ticker Ticker for the security. For cash positions use CASH.SEK.
     * @param acceptLanguage
     * @param daysBack
     * @returns instrument_InstrumentInfoResponse
     * @throws ApiError
     */
    public static getB2BV1AdvisorInstrumentsInfo(
        ticker: string,
        acceptLanguage?: 'en' | 'sv',
        daysBack?: number,
    ): CancelablePromise<instrument_InstrumentInfoResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/instruments/{ticker}/info',
            path: {
                'ticker': ticker,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'days_back': daysBack,
            },
        });
    }
    /**
     * /b2b/v1/advisor/integrations
     * @param organization
     * @returns b2b_v1_advisor_integrations_OrgIntegrations
     * @throws ApiError
     */
    public static getB2BV1AdvisorIntegrations(
        organization: string,
    ): CancelablePromise<b2b_v1_advisor_integrations_OrgIntegrations> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/integrations',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/advisor/organizations
     * @returns core_OrganizationSchemaItems
     * @throws ApiError
     */
    public static getB2BV1AdvisorOrganizations(): CancelablePromise<core_OrganizationSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/organizations',
        });
    }
    /**
     * /b2b/v1/advisor/positions/<client_id>
     * @param clientId
     * @param accountId
     * @returns positions_report_Positions
     * @throws ApiError
     */
    public static getB2BV1AdvisorPositions(
        clientId: string,
        accountId?: string,
    ): CancelablePromise<positions_report_Positions> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/positions/{client_id}',
            path: {
                'client_id': clientId,
            },
            query: {
                'account_id': accountId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/settings
     * @param organization
     * @returns b2b_v1_advisor_settings_OrgSettings
     * @throws ApiError
     */
    public static getB2BV1AdvisorSettings(
        organization: string,
    ): CancelablePromise<b2b_v1_advisor_settings_OrgSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/settings',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/advisor/settings
     * @param organization
     * @param requestBody
     * @returns b2b_v1_advisor_settings_OrgSettings
     * @throws ApiError
     */
    public static patchB2BV1AdvisorSettings(
        organization: string,
        requestBody?: b2b_v1_advisor_settings_OrgSettings,
    ): CancelablePromise<b2b_v1_advisor_settings_OrgSettings> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/advisor/settings',
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/settings
     * @param organization
     * @param requestBody
     * @returns b2b_v1_advisor_settings_OrgSettings
     * @throws ApiError
     */
    public static putB2BV1AdvisorSettings(
        organization: string,
        requestBody?: b2b_v1_advisor_settings_OrgSettings,
    ): CancelablePromise<b2b_v1_advisor_settings_OrgSettings> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/advisor/settings',
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/settings/admin
     * @param organization
     * @returns b2b_v1_advisor_settings_OrgAdminSettings
     * @throws ApiError
     */
    public static getB2BV1AdvisorSettingsAdmin(
        organization: string,
    ): CancelablePromise<b2b_v1_advisor_settings_OrgAdminSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/settings/admin',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/advisor/settings/admin
     * @param organization
     * @param requestBody
     * @returns b2b_v1_advisor_settings_OrgAdminSettings
     * @throws ApiError
     */
    public static putB2BV1AdvisorSettingsAdmin(
        organization: string,
        requestBody?: b2b_v1_advisor_settings_OrgAdminSettings,
    ): CancelablePromise<b2b_v1_advisor_settings_OrgAdminSettings> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/advisor/settings/admin',
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/settings/admin/delete-flanks-credentials
     * @param client
     * @param organization
     * @returns b2b_v1_advisor_settings_DeleteFlanksCredentialsResponse
     * @throws ApiError
     */
    public static postB2BV1AdvisorSettingsAdminDeleteFlanksCredentials(
        client?: string,
        organization?: string,
    ): CancelablePromise<b2b_v1_advisor_settings_DeleteFlanksCredentialsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/settings/admin/delete-flanks-credentials',
            query: {
                'client': client,
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/advisor/settings/admin/instruments
     * Ensure the Instruments used by Organization exists in the dataapp
     * @param organization
     * @returns b2b_v1_advisor_settings_JobStartedResponse
     * @throws ApiError
     */
    public static postB2BV1AdvisorSettingsAdminInstruments(
        organization?: string,
    ): CancelablePromise<b2b_v1_advisor_settings_JobStartedResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/settings/admin/instruments',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/advisor/settings/admin/product-lists
     * @param organization
     * @returns b2b_v1_advisor_settings_JobStartedResponse
     * @throws ApiError
     */
    public static postB2BV1AdvisorSettingsAdminProductLists(
        organization: string,
    ): CancelablePromise<b2b_v1_advisor_settings_JobStartedResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/settings/admin/product-lists',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/advisor/settings/admin/product-lists/svp
     * @param organization
     * @returns b2b_v1_advisor_settings_JobStartedResponse
     * @throws ApiError
     */
    public static postB2BV1AdvisorSettingsAdminProductListsSvp(
        organization: string,
    ): CancelablePromise<b2b_v1_advisor_settings_JobStartedResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/settings/admin/product-lists/svp',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/advisor/settings/app
     * @param organization
     * @returns app_v1_settings_AppSettings
     * @throws ApiError
     */
    public static getB2BV1AdvisorSettingsApp(
        organization: string,
    ): CancelablePromise<app_v1_settings_AppSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/settings/app',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/advisor/settings/app
     * @param organization
     * @param requestBody
     * @returns app_v1_settings_AppSettings
     * @throws ApiError
     */
    public static patchB2BV1AdvisorSettingsApp(
        organization: string,
        requestBody?: app_v1_settings_AppSettings,
    ): CancelablePromise<app_v1_settings_AppSettings> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/advisor/settings/app',
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/settings/app
     * @param organization
     * @param requestBody
     * @returns app_v1_settings_AppSettings
     * @throws ApiError
     */
    public static putB2BV1AdvisorSettingsApp(
        organization: string,
        requestBody?: app_v1_settings_AppSettings,
    ): CancelablePromise<app_v1_settings_AppSettings> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/advisor/settings/app',
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/token
     * @returns b2b_v1_advisor_client_ShareLinkToken
     * @throws ApiError
     */
    public static postB2BV1AdvisorToken(): CancelablePromise<b2b_v1_advisor_client_ShareLinkToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/token',
        });
    }
    /**
     * /b2b/v1/advisor/users
     * @param organization
     * @returns b2b_v1_advisor_users_UserDetailsSchemaItems
     * @throws ApiError
     */
    public static getB2BV1AdvisorUsers(
        organization: string,
    ): CancelablePromise<b2b_v1_advisor_users_UserDetailsSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/users',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/advisor/users
     * @param requestBody
     * @returns b2b_v1_advisor_users_CreateUser
     * @throws ApiError
     */
    public static postB2BV1AdvisorUsers(
        requestBody?: b2b_v1_advisor_users_CreateUser,
    ): CancelablePromise<b2b_v1_advisor_users_CreateUser> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/advisor/users',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/users/<user_id>
     * @param userId
     * @throws ApiError
     */
    public static deleteB2BV1AdvisorUsers(
        userId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/advisor/users/{user_id}',
            path: {
                'user_id': userId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/users/<user_id>
     * @param userId
     * @returns b2b_v1_advisor_users_UserDetails
     * @throws ApiError
     */
    public static getB2BV1AdvisorUsers1(
        userId: string,
    ): CancelablePromise<b2b_v1_advisor_users_UserDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/advisor/users/{user_id}',
            path: {
                'user_id': userId,
            },
        });
    }
    /**
     * /b2b/v1/advisor/users/<user_id>
     * @param userId
     * @param requestBody
     * @returns b2b_v1_advisor_users_UserDetails
     * @throws ApiError
     */
    public static patchB2BV1AdvisorUsers(
        userId: string,
        requestBody?: b2b_v1_advisor_users_UserDetails,
    ): CancelablePromise<b2b_v1_advisor_users_UserDetails> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/advisor/users/{user_id}',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/advisor/users/<user_id>
     * @param userId
     * @param requestBody
     * @returns b2b_v1_advisor_users_UserDetails
     * @throws ApiError
     */
    public static putB2BV1AdvisorUsers(
        userId: string,
        requestBody?: b2b_v1_advisor_users_UserDetails,
    ): CancelablePromise<b2b_v1_advisor_users_UserDetails> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/advisor/users/{user_id}',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/analytics/column-choices
     * Column choices available for analytics reports.
     * @returns marshmallow_schema_ColumnChoices
     * @throws ApiError
     */
    public static getB2BV1AnalyticsColumnChoices(): CancelablePromise<marshmallow_schema_ColumnChoices> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/analytics/column-choices',
        });
    }
    /**
     * /b2b/v1/analytics/grouping-choices
     * Grouping alternatives available for analytics reports.
     * @returns api_v2_analytics_choices_EnumSchemaItems
     * @throws ApiError
     */
    public static getB2BV1AnalyticsGroupingChoices(): CancelablePromise<api_v2_analytics_choices_EnumSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/analytics/grouping-choices',
        });
    }
    /**
     * /b2b/v1/analytics/reports
     * List analytics reports.
     * @param organization
     * @returns api_v2_analytics_reports_ListReportSchemaItems
     * @throws ApiError
     */
    public static getB2BV1AnalyticsReports(
        organization: string,
    ): CancelablePromise<api_v2_analytics_reports_ListReportSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/analytics/reports',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/analytics/reports
     * Save an analytics report.
     * @param requestBody
     * @returns api_v2_analytics_reports_SavedReportDetails
     * @throws ApiError
     */
    public static postB2BV1AnalyticsReports(
        requestBody?: b2b_v1_analytics_CreateReport,
    ): CancelablePromise<api_v2_analytics_reports_SavedReportDetails> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/analytics/reports',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/analytics/reports/new-from-default
     * Get a default analytics report.
     * @param organization
     * @param requestBody
     * @returns api_v2_analytics_unsaved_reports_UnsavedReportDetails
     * @throws ApiError
     */
    public static postB2BV1AnalyticsReportsNewFromDefault(
        organization: string,
        requestBody?: b2b_v1_analytics_CreateDefaultReport,
    ): CancelablePromise<api_v2_analytics_unsaved_reports_UnsavedReportDetails> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/analytics/reports/new-from-default',
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/analytics/reports/unsaved/<temp_report_id>
     * Delete the unsaved analytics report.
     * @param tempReportId
     * @throws ApiError
     */
    public static deleteB2BV1AnalyticsReportsUnsaved(
        tempReportId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/analytics/reports/unsaved/{temp_report_id}',
            path: {
                'temp_report_id': tempReportId,
            },
        });
    }
    /**
     * /b2b/v1/analytics/reports/unsaved/<temp_report_id>
     * Get the unsaved report.
     * @param tempReportId
     * @returns api_v2_analytics_unsaved_reports_UnsavedReportDetails
     * @throws ApiError
     */
    public static getB2BV1AnalyticsReportsUnsaved(
        tempReportId: string,
    ): CancelablePromise<api_v2_analytics_unsaved_reports_UnsavedReportDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/analytics/reports/unsaved/{temp_report_id}',
            path: {
                'temp_report_id': tempReportId,
            },
        });
    }
    /**
     * /b2b/v1/analytics/reports/unsaved/<temp_report_id>
     * @param tempReportId
     * @param organization
     * @param requestBody
     * @returns api_v2_analytics_unsaved_reports_UnsavedReportDetails
     * @throws ApiError
     */
    public static patchB2BV1AnalyticsReportsUnsaved(
        tempReportId: string,
        organization: string,
        requestBody?: api_v2_analytics_unsaved_reports_UpdateUnsavedReport,
    ): CancelablePromise<api_v2_analytics_unsaved_reports_UnsavedReportDetails> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/analytics/reports/unsaved/{temp_report_id}',
            path: {
                'temp_report_id': tempReportId,
            },
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/analytics/reports/unsaved/<temp_report_id>
     * @param tempReportId
     * @param organization
     * @param requestBody
     * @returns api_v2_analytics_unsaved_reports_UnsavedReportDetails
     * @throws ApiError
     */
    public static putB2BV1AnalyticsReportsUnsaved(
        tempReportId: string,
        organization: string,
        requestBody?: api_v2_analytics_unsaved_reports_UpdateUnsavedReport,
    ): CancelablePromise<api_v2_analytics_unsaved_reports_UnsavedReportDetails> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/analytics/reports/unsaved/{temp_report_id}',
            path: {
                'temp_report_id': tempReportId,
            },
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/analytics/reports/unsaved/<temp_report_id>/charts
     * @param tempReportId
     * @param organization
     * @param requestBody
     * @returns api_v2_analytics_unsaved_reports_UnsavedReportDetails
     * @throws ApiError
     */
    public static patchB2BV1AnalyticsReportsUnsavedCharts(
        tempReportId: string,
        organization: string,
        requestBody?: b2b_v1_analytics_UpdateCharts,
    ): CancelablePromise<api_v2_analytics_unsaved_reports_UnsavedReportDetails> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/analytics/reports/unsaved/{temp_report_id}/charts',
            path: {
                'temp_report_id': tempReportId,
            },
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/analytics/reports/unsaved/<temp_report_id>/charts
     * @param tempReportId
     * @param organization
     * @param requestBody
     * @returns api_v2_analytics_unsaved_reports_UnsavedReportDetails
     * @throws ApiError
     */
    public static putB2BV1AnalyticsReportsUnsavedCharts(
        tempReportId: string,
        organization: string,
        requestBody?: b2b_v1_analytics_UpdateCharts,
    ): CancelablePromise<api_v2_analytics_unsaved_reports_UnsavedReportDetails> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/analytics/reports/unsaved/{temp_report_id}/charts',
            path: {
                'temp_report_id': tempReportId,
            },
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/analytics/reports/unsaved/<temp_report_id>/task
     * @param tempReportId
     * @param organization
     * @throws ApiError
     */
    public static deleteB2BV1AnalyticsReportsUnsavedTask(
        tempReportId: string,
        organization: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/analytics/reports/unsaved/{temp_report_id}/task',
            path: {
                'temp_report_id': tempReportId,
            },
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/analytics/reports/<report_id>
     * @param reportId
     * @throws ApiError
     */
    public static deleteB2BV1AnalyticsReports(
        reportId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/analytics/reports/{report_id}',
            path: {
                'report_id': reportId,
            },
        });
    }
    /**
     * /b2b/v1/analytics/reports/<report_id>
     * Get an analytics report.
     * @param reportId
     * @returns api_v2_analytics_reports_SavedReportDetails
     * @throws ApiError
     */
    public static getB2BV1AnalyticsReports1(
        reportId: string,
    ): CancelablePromise<api_v2_analytics_reports_SavedReportDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/analytics/reports/{report_id}',
            path: {
                'report_id': reportId,
            },
        });
    }
    /**
     * /b2b/v1/analytics/reports/<report_id>
     * Update an analytics report.
     * @param reportId
     * @param organization
     * @param requestBody
     * @returns api_v2_analytics_reports_SavedReportDetails
     * @throws ApiError
     */
    public static patchB2BV1AnalyticsReports(
        reportId: string,
        organization: string,
        requestBody?: b2b_v1_analytics_RenameReport,
    ): CancelablePromise<api_v2_analytics_reports_SavedReportDetails> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/analytics/reports/{report_id}',
            path: {
                'report_id': reportId,
            },
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/analytics/reports/<report_id>
     * Update an analytics report.
     * @param reportId
     * @param organization
     * @param requestBody
     * @returns api_v2_analytics_reports_SavedReportDetails
     * @throws ApiError
     */
    public static putB2BV1AnalyticsReports(
        reportId: string,
        organization: string,
        requestBody?: b2b_v1_analytics_RenameReport,
    ): CancelablePromise<api_v2_analytics_reports_SavedReportDetails> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/analytics/reports/{report_id}',
            path: {
                'report_id': reportId,
            },
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/analytics/reports/<report_id>/export
     * @param reportId
     * @param fileType
     * @returns binary
     * @throws ApiError
     */
    public static postB2BV1AnalyticsReportsExport(
        reportId: string,
        fileType: 'csv' | 'xlsx',
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/analytics/reports/{report_id}/export',
            path: {
                'report_id': reportId,
            },
            query: {
                'file_type': fileType,
            },
        });
    }
    /**
     * /b2b/v1/analytics/reports/<report_id>/rows/export
     * @param reportId
     * @param fileType
     * @param rowIds
     * @returns binary
     * @throws ApiError
     */
    public static postB2BV1AnalyticsReportsRowsExport(
        reportId: string,
        fileType: 'csv' | 'xlsx',
        rowIds: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/analytics/reports/{report_id}/rows/export',
            path: {
                'report_id': reportId,
            },
            query: {
                'file_type': fileType,
                'row_ids': rowIds,
            },
        });
    }
    /**
     * /b2b/v1/analytics/reports/<report_id>/rows/<row_id>
     * Get a detailed view of report's row.
     * @param reportId
     * @param rowId
     * @param organization
     * @returns api_v2_calculate_portfolio_analytics_PortfolioAnalyticsResult
     * @throws ApiError
     */
    public static getB2BV1AnalyticsReportsRows(
        reportId: string,
        rowId: string,
        organization: string,
    ): CancelablePromise<api_v2_calculate_portfolio_analytics_PortfolioAnalyticsResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/analytics/reports/{report_id}/rows/{row_id}',
            path: {
                'report_id': reportId,
                'row_id': rowId,
            },
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/analytics/source-choices
     * Source choices available for analytics reports.
     * @returns marshmallow_schema_SourceChoices
     * @throws ApiError
     */
    public static getB2BV1AnalyticsSourceChoices(): CancelablePromise<marshmallow_schema_SourceChoices> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/analytics/source-choices',
        });
    }
    /**
     * /b2b/v1/asset-allocations
     * @param organization
     * @returns b2b_v1_asset_allocation_AssetAllocationResultSchemaItems
     * @throws ApiError
     */
    public static getB2BV1AssetAllocations(
        organization: string,
    ): CancelablePromise<b2b_v1_asset_allocation_AssetAllocationResultSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/asset-allocations',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/asset-allocations
     * @param requestBody
     * @returns b2b_v1_asset_allocation_AssetAllocationResult
     * @throws ApiError
     */
    public static postB2BV1AssetAllocations(
        requestBody?: b2b_v1_asset_allocation_CreateAssetAllocation,
    ): CancelablePromise<b2b_v1_asset_allocation_AssetAllocationResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/asset-allocations',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/asset-allocations/calcs
     * @param organization
     * @param requestBody
     * @returns risk_report_RiskReport
     * @throws ApiError
     */
    public static postB2BV1AssetAllocationsCalcs(
        organization: string,
        requestBody?: Array<b2b_v1_asset_allocation_UpsertAssetAllocationItems>,
    ): CancelablePromise<risk_report_RiskReport> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/asset-allocations/calcs',
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/asset-allocations/<asset_allocation_id>
     * @param assetAllocationId
     * @throws ApiError
     */
    public static deleteB2BV1AssetAllocations(
        assetAllocationId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/asset-allocations/{asset_allocation_id}',
            path: {
                'asset_allocation_id': assetAllocationId,
            },
        });
    }
    /**
     * /b2b/v1/asset-allocations/<asset_allocation_id>
     * @param assetAllocationId
     * @returns b2b_v1_asset_allocation_AssetAllocationResult
     * @throws ApiError
     */
    public static getB2BV1AssetAllocations1(
        assetAllocationId: string,
    ): CancelablePromise<b2b_v1_asset_allocation_AssetAllocationResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/asset-allocations/{asset_allocation_id}',
            path: {
                'asset_allocation_id': assetAllocationId,
            },
        });
    }
    /**
     * /b2b/v1/asset-allocations/<asset_allocation_id>
     * @param assetAllocationId
     * @param requestBody
     * @returns b2b_v1_asset_allocation_AssetAllocationResult
     * @throws ApiError
     */
    public static patchB2BV1AssetAllocations(
        assetAllocationId: string,
        requestBody?: b2b_v1_asset_allocation_UpdateAssetAllocation,
    ): CancelablePromise<b2b_v1_asset_allocation_AssetAllocationResult> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/asset-allocations/{asset_allocation_id}',
            path: {
                'asset_allocation_id': assetAllocationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/asset-allocations/<asset_allocation_id>
     * @param assetAllocationId
     * @param requestBody
     * @returns b2b_v1_asset_allocation_AssetAllocationResult
     * @throws ApiError
     */
    public static putB2BV1AssetAllocations(
        assetAllocationId: string,
        requestBody?: b2b_v1_asset_allocation_UpdateAssetAllocation,
    ): CancelablePromise<b2b_v1_asset_allocation_AssetAllocationResult> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/asset-allocations/{asset_allocation_id}',
            path: {
                'asset_allocation_id': assetAllocationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/asset-allocations/<asset_allocation_id>/items
     * @param assetAllocationId
     * @returns b2b_v1_asset_allocation_AssetAllocationFullResult
     * @throws ApiError
     */
    public static getB2BV1AssetAllocationsItems(
        assetAllocationId: string,
    ): CancelablePromise<b2b_v1_asset_allocation_AssetAllocationFullResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/asset-allocations/{asset_allocation_id}/items',
            path: {
                'asset_allocation_id': assetAllocationId,
            },
        });
    }
    /**
     * /b2b/v1/asset-allocations/<asset_allocation_id>/items
     * @param assetAllocationId
     * @param requestBody
     * @returns b2b_v1_asset_allocation_AssetAllocationFullResult
     * @throws ApiError
     */
    public static postB2BV1AssetAllocationsItems(
        assetAllocationId: string,
        requestBody?: Array<b2b_v1_asset_allocation_UpsertAssetAllocationItems>,
    ): CancelablePromise<b2b_v1_asset_allocation_AssetAllocationFullResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/asset-allocations/{asset_allocation_id}/items',
            path: {
                'asset_allocation_id': assetAllocationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/auth/login
     * @param requestBody
     * @returns b2b_v1_auth_Login
     * @throws ApiError
     */
    public static postB2BV1AuthLogin(
        requestBody?: b2b_v1_auth_Login,
    ): CancelablePromise<b2b_v1_auth_Login> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/auth/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/auth/logout
     * @throws ApiError
     */
    public static postB2BV1AuthLogout(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/auth/logout',
        });
    }
    /**
     * /b2b/v1/auth/user
     * @returns b2b_v1_auth_User
     * @throws ApiError
     */
    public static getB2BV1AuthUser(): CancelablePromise<b2b_v1_auth_User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/auth/user',
        });
    }
    /**
     * /b2b/v1/availability/market-regions
     * @throws ApiError
     */
    public static getB2BV1AvailabilityMarketRegions(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/availability/market-regions',
        });
    }
    /**
     * /b2b/v1/calc-params
     * @param organization
     * @returns api_v2_data_calc_params_CalcParamSchemaItems
     * @throws ApiError
     */
    public static getB2BV1CalcParams(
        organization: string,
    ): CancelablePromise<api_v2_data_calc_params_CalcParamSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/calc-params',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/calc-params
     * @param organization
     * @param requestBody
     * @returns api_v2_data_calc_params_CalcParam
     * @throws ApiError
     */
    public static postB2BV1CalcParams(
        organization: string,
        requestBody?: b2b_v1_calc_param_CreateCalcParamB2B,
    ): CancelablePromise<api_v2_data_calc_params_CalcParam> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/calc-params',
            query: {
                'organization': organization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/calc-params/export
     * @param fileType
     * @param organization
     * @returns binary
     * @throws ApiError
     */
    public static postB2BV1CalcParamsExport(
        fileType: 'xlsx' | 'csv',
        organization: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/calc-params/export',
            query: {
                'file_type': fileType,
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/calc-params/import
     * Import the Calc Params
     * @param organization
     * @param formData
     * @returns b2b_v1_calc_param_ImportCalcParamResponse
     * @throws ApiError
     */
    public static postB2BV1CalcParamsImport(
        organization: string,
        formData?: b2b_v1_calc_param_ImportCalcParam,
    ): CancelablePromise<b2b_v1_calc_param_ImportCalcParamResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/calc-params/import',
            query: {
                'organization': organization,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * /b2b/v1/calc-params/<calc_param_id>
     * @param calcParamId
     * @throws ApiError
     */
    public static deleteB2BV1CalcParams(
        calcParamId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/calc-params/{calc_param_id}',
            path: {
                'calc_param_id': calcParamId,
            },
        });
    }
    /**
     * /b2b/v1/calc-params/<calc_param_id>
     * @param calcParamId
     * @returns api_v2_data_calc_params_CalcParam
     * @throws ApiError
     */
    public static getB2BV1CalcParams1(
        calcParamId: string,
    ): CancelablePromise<api_v2_data_calc_params_CalcParam> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/calc-params/{calc_param_id}',
            path: {
                'calc_param_id': calcParamId,
            },
        });
    }
    /**
     * /b2b/v1/calc-params/<calc_param_id>
     * @param calcParamId
     * @param requestBody
     * @returns api_v2_data_calc_params_CalcParam
     * @throws ApiError
     */
    public static patchB2BV1CalcParams(
        calcParamId: string,
        requestBody?: b2b_v1_calc_param_UpdateCalcParamB2B,
    ): CancelablePromise<api_v2_data_calc_params_CalcParam> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/calc-params/{calc_param_id}',
            path: {
                'calc_param_id': calcParamId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/calc-params/<calc_param_id>
     * @param calcParamId
     * @param requestBody
     * @returns api_v2_data_calc_params_CalcParam
     * @throws ApiError
     */
    public static putB2BV1CalcParams(
        calcParamId: string,
        requestBody?: b2b_v1_calc_param_UpdateCalcParamB2B,
    ): CancelablePromise<api_v2_data_calc_params_CalcParam> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/calc-params/{calc_param_id}',
            path: {
                'calc_param_id': calcParamId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/accounts/<report_id>
     * @param reportId
     * @returns b2b_v1_users_AccountSchemaItems
     * @throws ApiError
     */
    public static getB2BV1ClientAccounts(
        reportId: string,
    ): CancelablePromise<b2b_v1_users_AccountSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/client/accounts/{report_id}',
            path: {
                'report_id': reportId,
            },
        });
    }
    /**
     * /b2b/v1/client/accounts/<report_id>
     * @param reportId
     * @param requestBody
     * @returns b2b_v1_users_Account
     * @throws ApiError
     */
    public static postB2BV1ClientAccounts(
        reportId: string,
        requestBody?: b2b_v1_users_Account,
    ): CancelablePromise<b2b_v1_users_Account> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/client/accounts/{report_id}',
            path: {
                'report_id': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/accounts/<report_id>/<account_id>
     * @param accountId
     * @param reportId
     * @throws ApiError
     */
    public static deleteB2BV1ClientAccounts(
        accountId: string,
        reportId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/client/accounts/{report_id}/{account_id}',
            path: {
                'account_id': accountId,
                'report_id': reportId,
            },
        });
    }
    /**
     * /b2b/v1/client/accounts/<report_id>/<account_id>
     * @param accountId
     * @param reportId
     * @param requestBody
     * @returns b2b_v1_users_Account
     * @throws ApiError
     */
    public static patchB2BV1ClientAccounts(
        accountId: string,
        reportId: string,
        requestBody?: b2b_v1_users_AccountUpdate,
    ): CancelablePromise<b2b_v1_users_Account> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/client/accounts/{report_id}/{account_id}',
            path: {
                'account_id': accountId,
                'report_id': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/accounts/<report_id>/<account_id>
     * @param accountId
     * @param reportId
     * @param requestBody
     * @returns b2b_v1_users_Account
     * @throws ApiError
     */
    public static putB2BV1ClientAccounts(
        accountId: string,
        reportId: string,
        requestBody?: b2b_v1_users_AccountUpdate,
    ): CancelablePromise<b2b_v1_users_Account> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/client/accounts/{report_id}/{account_id}',
            path: {
                'account_id': accountId,
                'report_id': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/connect/complete
     * @param requestBody
     * @throws ApiError
     */
    public static postB2BV1ClientConnectComplete(
        requestBody?: b2b_v1_connect_ConnectComplete,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/client/connect/complete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/connect/data-providers
     * @param organization
     * @param isTest
     * @returns data_providers_DataProviderSchemaItems1
     * @throws ApiError
     */
    public static getB2BV1ClientConnectDataProviders(
        organization: string,
        isTest?: boolean,
    ): CancelablePromise<data_providers_DataProviderSchemaItems1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/client/connect/data-providers',
            query: {
                'is_test': isTest,
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/client/connect/delete
     * @param requestBody
     * @throws ApiError
     */
    public static postB2BV1ClientConnectDelete(
        requestBody?: b2b_v1_connect_ConnectDelete,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/client/connect/delete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/connect/init
     * @param requestBody
     * @returns b2b_v1_connect_ConnectInitResponse
     * @throws ApiError
     */
    public static postB2BV1ClientConnectInit(
        requestBody?: b2b_v1_connect_ConnectInit,
    ): CancelablePromise<b2b_v1_connect_ConnectInitResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/client/connect/init',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/connect/start
     * @param requestBody
     * @returns b2b_v1_core_UrlResponse
     * @throws ApiError
     */
    public static postB2BV1ClientConnectStart(
        requestBody?: b2b_v1_connect_ConnectStart,
    ): CancelablePromise<b2b_v1_core_UrlResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/client/connect/start',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/connect/status-message
     * @param organization
     * @returns b2b_v1_connect_StatusMessageResult
     * @throws ApiError
     */
    public static getB2BV1ClientConnectStatusMessage(
        organization: string,
    ): CancelablePromise<b2b_v1_connect_StatusMessageResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/client/connect/status-message',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/client/connect/update
     * @param requestBody
     * @throws ApiError
     */
    public static patchB2BV1ClientConnectUpdate(
        requestBody?: b2b_v1_connect_ConnectUpdate,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/client/connect/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/connect/update
     * @param requestBody
     * @throws ApiError
     */
    public static putB2BV1ClientConnectUpdate(
        requestBody?: b2b_v1_connect_ConnectUpdate,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/client/connect/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/connections/<report_id>
     * @param reportId
     * @returns connections_DataSessionConnectionSchemaItems
     * @throws ApiError
     */
    public static getB2BV1ClientConnections(
        reportId: string,
    ): CancelablePromise<connections_DataSessionConnectionSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/client/connections/{report_id}',
            path: {
                'report_id': reportId,
            },
        });
    }
    /**
     * /b2b/v1/client/connections/<report_id>/<institution_id>
     * @param institutionId
     * @param reportId
     * @throws ApiError
     */
    public static deleteB2BV1ClientConnections(
        institutionId: string,
        reportId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/client/connections/{report_id}/{institution_id}',
            path: {
                'institution_id': institutionId,
                'report_id': reportId,
            },
        });
    }
    /**
     * /b2b/v1/client/holdings-report/<report_id>
     * @param reportId
     * @param acceptLanguage
     * @returns b2b_v1_advisor_holding_reports_HoldingsReportResponse
     * @throws ApiError
     */
    public static getB2BV1ClientHoldingsReport(
        reportId: string,
        acceptLanguage?: 'en' | 'sv',
    ): CancelablePromise<b2b_v1_advisor_holding_reports_HoldingsReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/client/holdings-report/{report_id}',
            path: {
                'report_id': reportId,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
        });
    }
    /**
     * /b2b/v1/client/holdings-report/<report_id>/dismiss-insight/<insight_id>
     * @param insightId
     * @param reportId
     * @throws ApiError
     */
    public static patchB2BV1ClientHoldingsReportDismissInsight(
        insightId: string,
        reportId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/client/holdings-report/{report_id}/dismiss-insight/{insight_id}',
            path: {
                'insight_id': insightId,
                'report_id': reportId,
            },
        });
    }
    /**
     * /b2b/v1/client/holdings-report/<report_id>/dismiss-insight/<insight_id>
     * @param insightId
     * @param reportId
     * @throws ApiError
     */
    public static putB2BV1ClientHoldingsReportDismissInsight(
        insightId: string,
        reportId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/client/holdings-report/{report_id}/dismiss-insight/{insight_id}',
            path: {
                'insight_id': insightId,
                'report_id': reportId,
            },
        });
    }
    /**
     * /b2b/v1/client/holdings-report/<report_id>/pdf
     * @param reportId
     * @param taskId
     * @param acceptLanguage
     * @returns b2b_v1_advisor_holding_reports_HoldingsReportExportResponse
     * @throws ApiError
     */
    public static getB2BV1ClientHoldingsReportPdf(
        reportId: string,
        taskId: string,
        acceptLanguage?: 'en' | 'sv',
    ): CancelablePromise<b2b_v1_advisor_holding_reports_HoldingsReportExportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/client/holdings-report/{report_id}/pdf',
            path: {
                'report_id': reportId,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'task_id': taskId,
            },
        });
    }
    /**
     * /b2b/v1/client/holdings-report/<report_id>/pdf
     * @param reportId
     * @param acceptLanguage
     * @returns b2b_v1_advisor_holding_reports_HoldingsReportExportResponse
     * @throws ApiError
     */
    public static postB2BV1ClientHoldingsReportPdf(
        reportId: string,
        acceptLanguage?: 'en' | 'sv',
    ): CancelablePromise<b2b_v1_advisor_holding_reports_HoldingsReportExportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/client/holdings-report/{report_id}/pdf',
            path: {
                'report_id': reportId,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
        });
    }
    /**
     * /b2b/v1/client/holdings-report/<report_id>/pdf/result
     * @param reportId
     * @param taskId
     * @returns binary
     * @throws ApiError
     */
    public static postB2BV1ClientHoldingsReportPdfResult(
        reportId: string,
        taskId: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/client/holdings-report/{report_id}/pdf/result',
            path: {
                'report_id': reportId,
            },
            query: {
                'task_id': taskId,
            },
        });
    }
    /**
     * /b2b/v1/client/holdings-reports
     * @param clientToken
     * @returns b2b_v1_advisor_holding_reports_HoldingsReportSchemaItems1
     * @throws ApiError
     */
    public static getB2BV1ClientHoldingsReports(
        clientToken: string,
    ): CancelablePromise<b2b_v1_advisor_holding_reports_HoldingsReportSchemaItems1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/client/holdings-reports',
            query: {
                'client_token': clientToken,
            },
        });
    }
    /**
     * /b2b/v1/client/holdings-reports
     * @param clientToken
     * @param requestBody
     * @returns b2b_v1_advisor_holding_reports_CreateHoldingsReportResponse
     * @throws ApiError
     */
    public static postB2BV1ClientHoldingsReports(
        clientToken: string,
        requestBody?: b2b_v1_advisor_holding_reports_CreateHoldingsReport,
    ): CancelablePromise<b2b_v1_advisor_holding_reports_CreateHoldingsReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/client/holdings-reports',
            query: {
                'client_token': clientToken,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/instruments/search
     * @param q
     * @param page
     * @param types
     * @returns instrument_InstrumentsSearchSchemaItems
     * @throws ApiError
     */
    public static getB2BV1ClientInstrumentsSearch(
        q: string,
        page?: number,
        types?: string,
    ): CancelablePromise<instrument_InstrumentsSearchSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/client/instruments/search',
            query: {
                'page': page,
                'q': q,
                'types': types,
            },
        });
    }
    /**
     * /b2b/v1/client/instruments/<ticker>/info
     * @param ticker Ticker for the security. For cash positions use CASH.SEK.
     * @param organization
     * @param acceptLanguage
     * @param daysBack
     * @returns instrument_InstrumentInfoResponse
     * @throws ApiError
     */
    public static getB2BV1ClientInstrumentsInfo(
        ticker: string,
        organization: string,
        acceptLanguage?: 'en' | 'sv',
        daysBack?: number,
    ): CancelablePromise<instrument_InstrumentInfoResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/client/instruments/{ticker}/info',
            path: {
                'ticker': ticker,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'days_back': daysBack,
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/client/instruments/<ticker>/latest-price
     * @param ticker
     * @returns instrument_InstrumentPrice
     * @throws ApiError
     */
    public static getB2BV1ClientInstrumentsLatestPrice(
        ticker: string,
    ): CancelablePromise<instrument_InstrumentPrice> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/client/instruments/{ticker}/latest-price',
            path: {
                'ticker': ticker,
            },
        });
    }
    /**
     * /b2b/v1/client/positions/<report_id>
     * @param reportId
     * @returns b2b_v1_users_PositionDetailsSchemaItems
     * @throws ApiError
     */
    public static getB2BV1ClientPositions(
        reportId: string,
    ): CancelablePromise<b2b_v1_users_PositionDetailsSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/client/positions/{report_id}',
            path: {
                'report_id': reportId,
            },
        });
    }
    /**
     * /b2b/v1/client/positions/<report_id>
     * @param reportId
     * @param requestBody
     * @returns b2b_v1_users_Position
     * @throws ApiError
     */
    public static postB2BV1ClientPositions(
        reportId: string,
        requestBody?: b2b_v1_users_PositionsCreate,
    ): CancelablePromise<b2b_v1_users_Position> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/client/positions/{report_id}',
            path: {
                'report_id': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/positions/<report_id>/<position_id>
     * @param positionId
     * @param reportId
     * @throws ApiError
     */
    public static deleteB2BV1ClientPositions(
        positionId: string,
        reportId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/client/positions/{report_id}/{position_id}',
            path: {
                'position_id': positionId,
                'report_id': reportId,
            },
        });
    }
    /**
     * /b2b/v1/client/positions/<report_id>/<position_id>
     * @param positionId
     * @param reportId
     * @param requestBody
     * @returns b2b_v1_users_Position
     * @throws ApiError
     */
    public static patchB2BV1ClientPositions(
        positionId: string,
        reportId: string,
        requestBody?: b2b_v1_users_PositionUpdate,
    ): CancelablePromise<b2b_v1_users_Position> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/client/positions/{report_id}/{position_id}',
            path: {
                'position_id': positionId,
                'report_id': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/client/positions/<report_id>/<position_id>
     * @param positionId
     * @param reportId
     * @param requestBody
     * @returns b2b_v1_users_Position
     * @throws ApiError
     */
    public static putB2BV1ClientPositions(
        positionId: string,
        reportId: string,
        requestBody?: b2b_v1_users_PositionUpdate,
    ): CancelablePromise<b2b_v1_users_Position> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/client/positions/{report_id}/{position_id}',
            path: {
                'position_id': positionId,
                'report_id': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/demo/organizations
     * @returns b2b_v1_demo_OrganizationSchemaItems
     * @throws ApiError
     */
    public static getB2BV1DemoOrganizations(): CancelablePromise<b2b_v1_demo_OrganizationSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/demo/organizations',
        });
    }
    /**
     * /b2b/v1/docs
     * @throws ApiError
     */
    public static getB2BV1Docs(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/docs',
        });
    }
    /**
     * /b2b/v1/feedback
     * @param requestBody
     * @returns b2b_v1_feedback_Feedback
     * @throws ApiError
     */
    public static postB2BV1Feedback(
        requestBody?: b2b_v1_feedback_Feedback,
    ): CancelablePromise<b2b_v1_feedback_Feedback> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/feedback',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/instrument-types
     * @returns marshmallow_schema_InstrumentTypes
     * @throws ApiError
     */
    public static getB2BV1InstrumentTypes(): CancelablePromise<marshmallow_schema_InstrumentTypes> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/instrument-types',
        });
    }
    /**
     * /b2b/v1/pensions/calculate
     *
     * Returns a list of allowed values per attribute for calc input.
     *
     * @returns b2b_v1_pensions_PensionMeta
     * @throws ApiError
     */
    public static getB2BV1PensionsCalculate(): CancelablePromise<Array<b2b_v1_pensions_PensionMeta>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/pensions/calculate',
        });
    }
    /**
     * /b2b/v1/pensions/calculate
     *
     * Performs calculations.
     *
     * @param requestBody
     * @returns b2b_v1_pensions_PensionOutput
     * @throws ApiError
     */
    public static postB2BV1PensionsCalculate(
        requestBody?: b2b_v1_pensions_PensionInput,
    ): CancelablePromise<b2b_v1_pensions_PensionOutput> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/pensions/calculate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/benchmark-portfolios
     * @param organization
     * @returns portfolio_benchmark_PortfolioBenchmarkSchemaItems
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderBenchmarkPortfolios(
        organization: string,
    ): CancelablePromise<portfolio_benchmark_PortfolioBenchmarkSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/benchmark-portfolios',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/benchmark-portfolios
     * @param requestBody
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderBenchmarkPortfolios(
        requestBody?: b2b_v1_portfolio_builder_portfolio_benchmark_CreatePortfolioBenchmark,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/benchmark-portfolios',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/benchmark-portfolios/<portfolio_benchmark_id>
     * @param portfolioBenchmarkId
     * @throws ApiError
     */
    public static deleteB2BV1PortfolioBuilderBenchmarkPortfolios(
        portfolioBenchmarkId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/portfolio-builder/benchmark-portfolios/{portfolio_benchmark_id}',
            path: {
                'portfolio_benchmark_id': portfolioBenchmarkId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/benchmark-portfolios/<portfolio_benchmark_id>
     * @param portfolioBenchmarkId
     * @returns portfolio_benchmark_PortfolioBenchmark
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderBenchmarkPortfolios1(
        portfolioBenchmarkId: string,
    ): CancelablePromise<portfolio_benchmark_PortfolioBenchmark> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/benchmark-portfolios/{portfolio_benchmark_id}',
            path: {
                'portfolio_benchmark_id': portfolioBenchmarkId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/benchmark-portfolios/<portfolio_benchmark_id>
     * @param portfolioBenchmarkId
     * @param requestBody
     * @returns portfolio_benchmark_PortfolioBenchmark
     * @throws ApiError
     */
    public static patchB2BV1PortfolioBuilderBenchmarkPortfolios(
        portfolioBenchmarkId: string,
        requestBody?: portfolio_benchmark_UpdatePortfolioBenchmark,
    ): CancelablePromise<portfolio_benchmark_PortfolioBenchmark> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/portfolio-builder/benchmark-portfolios/{portfolio_benchmark_id}',
            path: {
                'portfolio_benchmark_id': portfolioBenchmarkId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/benchmark-portfolios/<portfolio_benchmark_id>
     * @param portfolioBenchmarkId
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderBenchmarkPortfolios1(
        portfolioBenchmarkId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/benchmark-portfolios/{portfolio_benchmark_id}',
            path: {
                'portfolio_benchmark_id': portfolioBenchmarkId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/book/proposals/<proposal_id>
     * @param proposalId
     * @returns b2b_v1_portfolio_builder_portfolio_proposal_BookPortfolioProposalResponse
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderBookProposals(
        proposalId: string,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_proposal_BookPortfolioProposalResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/book/proposals/{proposal_id}',
            path: {
                'proposal_id': proposalId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/calculate/benchmark
     * @param organization
     * @param portfolioBenchmarkIds
     * @param period
     * @returns portfolio_benchmark_PortfoliosBenchmarkResult
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderCalculateBenchmark(
        organization: string,
        portfolioBenchmarkIds: string,
        period: 1 | 2 | 3 | 4 | 5 = 2,
    ): CancelablePromise<portfolio_benchmark_PortfoliosBenchmarkResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/calculate/benchmark',
            query: {
                'organization': organization,
                'period': period,
                'portfolio_benchmark_ids': portfolioBenchmarkIds,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/calculate/mean-optimal-proposal
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_portfolio_proposal_OptimalPortfolioProposalCalcsResponse
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderCalculateMeanOptimalProposal(
        requestBody?: b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalCalcs,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_proposal_OptimalPortfolioProposalCalcsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/calculate/mean-optimal-proposal',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/calculate/optimal-proposal
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_portfolio_proposal_OptimalPortfolioProposalCalcsResponse
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderCalculateOptimalProposal(
        requestBody?: b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalCalcs,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_proposal_OptimalPortfolioProposalCalcsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/calculate/optimal-proposal',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/calculate/proposals
     * @param acceptLanguage
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalCalcsResponse
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderCalculateProposals(
        acceptLanguage?: 'en' | 'sv',
        requestBody?: b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalCalcs,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalCalcsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/calculate/proposals',
            headers: {
                'Accept-Language': acceptLanguage,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-list-filters
     * @param organization
     * @param assetListId
     * @returns b2b_v1_portfolio_builder_asset_list_filter_AssetsListFilterSchemaItems
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderDataAssetListFilters(
        organization: string,
        assetListId?: string,
    ): CancelablePromise<b2b_v1_portfolio_builder_asset_list_filter_AssetsListFilterSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/data/asset-list-filters',
            query: {
                'asset_list_id': assetListId,
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-list-filters/batch
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_asset_list_filter_BatchOutputAssetListFilter
     * @throws ApiError
     */
    public static putB2BV1PortfolioBuilderDataAssetListFiltersBatch(
        requestBody?: Array<b2b_v1_portfolio_builder_asset_list_filter_UpdateAssetListFilterList>,
    ): CancelablePromise<b2b_v1_portfolio_builder_asset_list_filter_BatchOutputAssetListFilter> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/portfolio-builder/data/asset-list-filters/batch',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-list-filters/export
     * @param fileType
     * @param organization
     * @returns binary
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderDataAssetListFiltersExport(
        fileType: 'xlsx' | 'csv',
        organization: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/data/asset-list-filters/export',
            query: {
                'file_type': fileType,
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-list-filters/import
     * Import the Asset Lists
     * @param organization
     * @param formData
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderDataAssetListFiltersImport(
        organization: string,
        formData?: b2b_v1_portfolio_builder_asset_list_filter_ImportAssetListsFilters,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/data/asset-list-filters/import',
            query: {
                'organization': organization,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-list-filters/schema
     * @returns b2b_v1_portfolio_builder_asset_list_AssetListMetaSchemaItems
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderDataAssetListFiltersSchema(): CancelablePromise<b2b_v1_portfolio_builder_asset_list_AssetListMetaSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/data/asset-list-filters/schema',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-list-filters/<asset_list_filter_id>
     * @param assetListFilterId
     * @throws ApiError
     */
    public static deleteB2BV1PortfolioBuilderDataAssetListFilters(
        assetListFilterId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/portfolio-builder/data/asset-list-filters/{asset_list_filter_id}',
            path: {
                'asset_list_filter_id': assetListFilterId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-list-filters/<asset_list_filter_id>
     * @param assetListFilterId
     * @returns b2b_v1_portfolio_builder_asset_list_filter_AssetsListFilter
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderDataAssetListFilters1(
        assetListFilterId: string,
    ): CancelablePromise<b2b_v1_portfolio_builder_asset_list_filter_AssetsListFilter> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/data/asset-list-filters/{asset_list_filter_id}',
            path: {
                'asset_list_filter_id': assetListFilterId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-lists
     * @param organization
     * @param includeArchived
     * @param type
     * @returns b2b_v1_portfolio_builder_asset_list_AssetListResultSchemaItems
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderDataAssetLists(
        organization: string,
        includeArchived: boolean = false,
        type?: 'portfolio_builder' | 'asset_class',
    ): CancelablePromise<b2b_v1_portfolio_builder_asset_list_AssetListResultSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/data/asset-lists',
            query: {
                'include_archived': includeArchived,
                'organization': organization,
                'type': type,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-lists
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_asset_list_AssetListResult
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderDataAssetLists(
        requestBody?: b2b_v1_portfolio_builder_asset_list_CreateAssetList,
    ): CancelablePromise<b2b_v1_portfolio_builder_asset_list_AssetListResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/data/asset-lists',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-lists/<asset_list_id>
     * @param assetListId
     * @throws ApiError
     */
    public static deleteB2BV1PortfolioBuilderDataAssetLists(
        assetListId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/portfolio-builder/data/asset-lists/{asset_list_id}',
            path: {
                'asset_list_id': assetListId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-lists/<asset_list_id>
     * @param assetListId
     * @returns b2b_v1_portfolio_builder_asset_list_AssetListResult
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderDataAssetLists1(
        assetListId: string,
    ): CancelablePromise<b2b_v1_portfolio_builder_asset_list_AssetListResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/data/asset-lists/{asset_list_id}',
            path: {
                'asset_list_id': assetListId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-lists/<asset_list_id>
     * @param assetListId
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_asset_list_AssetListResult
     * @throws ApiError
     */
    public static patchB2BV1PortfolioBuilderDataAssetLists(
        assetListId: string,
        requestBody?: b2b_v1_portfolio_builder_asset_list_UpdateAssetList,
    ): CancelablePromise<b2b_v1_portfolio_builder_asset_list_AssetListResult> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/portfolio-builder/data/asset-lists/{asset_list_id}',
            path: {
                'asset_list_id': assetListId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-lists/<asset_list_id>
     * @param assetListId
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_asset_list_AssetListResult
     * @throws ApiError
     */
    public static putB2BV1PortfolioBuilderDataAssetLists(
        assetListId: string,
        requestBody?: b2b_v1_portfolio_builder_asset_list_UpdateAssetList,
    ): CancelablePromise<b2b_v1_portfolio_builder_asset_list_AssetListResult> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/portfolio-builder/data/asset-lists/{asset_list_id}',
            path: {
                'asset_list_id': assetListId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/asset-lists/<asset_list_id>/validate-asset-list-filters
     * @param assetListId
     * @returns b2b_v1_portfolio_builder_asset_list_AssetListFilterWarning
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderDataAssetListsValidateAssetListFilters(
        assetListId: string,
    ): CancelablePromise<Array<b2b_v1_portfolio_builder_asset_list_AssetListFilterWarning>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/data/asset-lists/{asset_list_id}/validate-asset-list-filters',
            path: {
                'asset_list_id': assetListId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/product-lists/export
     * @param fileType
     * @param organization
     * @returns binary
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderDataProductListsExport(
        fileType: 'xlsx' | 'csv',
        organization: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/data/product-lists/export',
            query: {
                'file_type': fileType,
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/product-lists/import
     * Import the Product Lists
     * @param organization
     * @param formData
     * @returns b2b_v1_portfolio_builder_asset_list_ImportProductListsResponse
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderDataProductListsImport(
        organization: string,
        formData?: b2b_v1_portfolio_builder_asset_list_ImportProductLists,
    ): CancelablePromise<b2b_v1_portfolio_builder_asset_list_ImportProductListsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/data/product-lists/import',
            query: {
                'organization': organization,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/proposals
     * @param organization
     * @param clientId
     * @param page
     * @param pageSize
     * @param search
     * @param sortBy
     * @returns b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalResultSchemaItems
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderDataProposals(
        organization: string,
        clientId?: string,
        page?: number,
        pageSize?: number,
        search?: string,
        sortBy?: string,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalResultSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/data/proposals',
            query: {
                'client_id': clientId,
                'organization': organization,
                'page': page,
                'page_size': pageSize,
                'search': search,
                'sort_by': sortBy,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/proposals
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalResult
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderDataProposals(
        requestBody?: b2b_v1_portfolio_builder_portfolio_proposal_CreatePortfolioProposal,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/data/proposals',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/proposals/export
     * Returns the XLSX or PDF file in the response body
     * @param fileType
     * @param proposalIds
     * @param acceptLanguage
     * @param riskPeriod
     * @returns binary
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderDataProposalsExport(
        fileType: 'pdf' | 'xlsx',
        proposalIds: string,
        acceptLanguage?: 'en' | 'sv',
        riskPeriod?: number,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/data/proposals/export',
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'file_type': fileType,
                'proposal_ids': proposalIds,
                'risk_period': riskPeriod,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/proposals/<proposal_id>
     * @param proposalId
     * @throws ApiError
     */
    public static deleteB2BV1PortfolioBuilderDataProposals(
        proposalId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/portfolio-builder/data/proposals/{proposal_id}',
            path: {
                'proposal_id': proposalId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/proposals/<proposal_id>
     * @param proposalId
     * @param acceptLanguage
     * @param riskPeriod
     * @returns b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalFullResult
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderDataProposals1(
        proposalId: string,
        acceptLanguage?: 'en' | 'sv',
        riskPeriod?: number,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalFullResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/data/proposals/{proposal_id}',
            path: {
                'proposal_id': proposalId,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
            query: {
                'risk_period': riskPeriod,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/proposals/<proposal_id>
     * @param proposalId
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalResult
     * @throws ApiError
     */
    public static patchB2BV1PortfolioBuilderDataProposals(
        proposalId: string,
        requestBody?: b2b_v1_portfolio_builder_portfolio_proposal_UpdatePortfolioProposal,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalResult> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/portfolio-builder/data/proposals/{proposal_id}',
            path: {
                'proposal_id': proposalId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/proposals/<proposal_id>
     * @param proposalId
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalResult
     * @throws ApiError
     */
    public static putB2BV1PortfolioBuilderDataProposals(
        proposalId: string,
        requestBody?: b2b_v1_portfolio_builder_portfolio_proposal_UpdatePortfolioProposal,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalResult> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/portfolio-builder/data/proposals/{proposal_id}',
            path: {
                'proposal_id': proposalId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/proposals/<proposal_id>/external-positions
     * @param proposalId
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_portfolio_proposal_ExternalPosition
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderDataProposalsExternalPositions(
        proposalId: string,
        requestBody?: b2b_v1_portfolio_builder_portfolio_proposal_CreateExternalPosition,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_proposal_ExternalPosition> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/data/proposals/{proposal_id}/external-positions',
            path: {
                'proposal_id': proposalId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/proposals/<proposal_id>/external-positions/<external_position_id>
     * @param externalPositionId
     * @param proposalId
     * @throws ApiError
     */
    public static deleteB2BV1PortfolioBuilderDataProposalsExternalPositions(
        externalPositionId: string,
        proposalId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/portfolio-builder/data/proposals/{proposal_id}/external-positions/{external_position_id}',
            path: {
                'external_position_id': externalPositionId,
                'proposal_id': proposalId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/proposals/<proposal_id>/external-positions/<external_position_id>
     * @param externalPositionId
     * @param proposalId
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_portfolio_proposal_ExternalPosition
     * @throws ApiError
     */
    public static patchB2BV1PortfolioBuilderDataProposalsExternalPositions(
        externalPositionId: string,
        proposalId: string,
        requestBody?: b2b_v1_portfolio_builder_portfolio_proposal_UpdateExternalPosition,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_proposal_ExternalPosition> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/portfolio-builder/data/proposals/{proposal_id}/external-positions/{external_position_id}',
            path: {
                'external_position_id': externalPositionId,
                'proposal_id': proposalId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/proposals/<proposal_id>/external-positions/<external_position_id>
     * @param externalPositionId
     * @param proposalId
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_portfolio_proposal_ExternalPosition
     * @throws ApiError
     */
    public static putB2BV1PortfolioBuilderDataProposalsExternalPositions(
        externalPositionId: string,
        proposalId: string,
        requestBody?: b2b_v1_portfolio_builder_portfolio_proposal_UpdateExternalPosition,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_proposal_ExternalPosition> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/portfolio-builder/data/proposals/{proposal_id}/external-positions/{external_position_id}',
            path: {
                'external_position_id': externalPositionId,
                'proposal_id': proposalId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/templates
     * @param organization
     * @returns b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResultSchemaItems
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderDataTemplates(
        organization: string,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResultSchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/data/templates',
            query: {
                'organization': organization,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/templates
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResult
     * @throws ApiError
     */
    public static postB2BV1PortfolioBuilderDataTemplates(
        requestBody?: b2b_v1_portfolio_builder_portfolio_template_CreatePortfolioTemplate,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/portfolio-builder/data/templates',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/templates/<template_id>
     * @param templateId
     * @throws ApiError
     */
    public static deleteB2BV1PortfolioBuilderDataTemplates(
        templateId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/b2b/v1/portfolio-builder/data/templates/{template_id}',
            path: {
                'template_id': templateId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/templates/<template_id>
     * @param templateId
     * @returns b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResult
     * @throws ApiError
     */
    public static getB2BV1PortfolioBuilderDataTemplates1(
        templateId: string,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/portfolio-builder/data/templates/{template_id}',
            path: {
                'template_id': templateId,
            },
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/templates/<template_id>
     * @param templateId
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResult
     * @throws ApiError
     */
    public static patchB2BV1PortfolioBuilderDataTemplates(
        templateId: string,
        requestBody?: b2b_v1_portfolio_builder_portfolio_template_UpdatePortfolioTemplate,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResult> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/b2b/v1/portfolio-builder/data/templates/{template_id}',
            path: {
                'template_id': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/portfolio-builder/data/templates/<template_id>
     * @param templateId
     * @param requestBody
     * @returns b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResult
     * @throws ApiError
     */
    public static putB2BV1PortfolioBuilderDataTemplates(
        templateId: string,
        requestBody?: b2b_v1_portfolio_builder_portfolio_template_UpdatePortfolioTemplate,
    ): CancelablePromise<b2b_v1_portfolio_builder_portfolio_template_PortfolioTemplateResult> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/b2b/v1/portfolio-builder/data/templates/{template_id}',
            path: {
                'template_id': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/recovery/reset-password/<code>
     * @param code
     * @returns recovery_ResetPassword
     * @throws ApiError
     */
    public static getB2BV1RecoveryResetPassword(
        code: string,
    ): CancelablePromise<recovery_ResetPassword> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/recovery/reset-password/{code}',
            path: {
                'code': code,
            },
        });
    }
    /**
     * /b2b/v1/recovery/reset-password/<code>
     * @param code
     * @param requestBody
     * @throws ApiError
     */
    public static postB2BV1RecoveryResetPassword(
        code: string,
        requestBody?: recovery_ResetPassword,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/recovery/reset-password/{code}',
            path: {
                'code': code,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/recovery/send-reset-password-email
     * @param requestBody
     * @throws ApiError
     */
    public static postB2BV1RecoverySendResetPasswordEmail(
        requestBody?: recovery_SendResetPasswordEmailOrg,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/b2b/v1/recovery/send-reset-password-email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /b2b/v1/system-status/events
     * @param eventType
     * @param status
     * @returns system_status_SystemStatusEventsBodySchemaItems
     * @throws ApiError
     */
    public static getB2BV1SystemStatusEvents(
        eventType?: 'incident' | 'planned_maintenance',
        status?: 'scheduled' | 'ongoing' | 'completed',
    ): CancelablePromise<system_status_SystemStatusEventsBodySchemaItems> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/b2b/v1/system-status/events',
            query: {
                'event_type': eventType,
                'status': status,
            },
        });
    }
}
